import { UpperCasePipe } from '@angular/common';
import { Component, OnInit, inject, signal, computed } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { GenesysCloudAPI, GenesysCloudAPIRegion, US_EAST_1 } from '@dictionaries/genesys-cloud-aws-region-dictionary';
import { environment } from '@environments/environment';
import { GenesysCloudAPIRegionGroup } from '@enums/genesys-cloud-region-group.enum';
import { PlatformAPIClientAuthorizationService } from '@services/platform-api-client-authorization.service';
import { AppIconRegistryService } from '@services/app-icon-registry.service';

const REGION_GROUPS: GenesysCloudAPIRegionGroup[] = [
  GenesysCloudAPIRegionGroup.Americas,
  GenesysCloudAPIRegionGroup.Europe,
  GenesysCloudAPIRegionGroup.MiddleEast,
  GenesysCloudAPIRegionGroup.AsiaPacific,
];

@Component({
  selector: 'app-welcome-home',
  imports: [
    UpperCasePipe,
    FormsModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './welcome-home.component.html',
  styleUrl: './welcome-home.component.scss',
})
export class WelcomeHomeComponent implements OnInit {
  private iconRegistryService = inject(AppIconRegistryService);
  private authService = inject(PlatformAPIClientAuthorizationService);

  readonly limitedRegionView = environment.featureFlags.limitedRegionView;
  regions: GenesysCloudAPIRegion[] = this.limitedRegionView ? [US_EAST_1] : GenesysCloudAPI;
  searchQuery = signal('');
  readonly groups = REGION_GROUPS;

  filteredRegions = computed(() => {
    const q = this.searchQuery().toLowerCase().trim();
    if (!q) return this.regions;
    return this.regions.filter(
      (r) =>
        r.label.toLowerCase().includes(q) ||
        r.awsGenericRegion.toLowerCase().includes(q) ||
        r.group.toLowerCase().includes(q),
    );
  });

  groupedRegions = computed(() => {
    const filtered = this.filteredRegions();
    return REGION_GROUPS.map((group) => ({
      group,
      regions: filtered.filter((r) => r.group === group),
    })).filter((g) => g.regions.length > 0);
  });

  private router = inject(Router);

  ngOnInit(): void {
    this.iconRegistryService.start();
  }

  onRegionClick(region: GenesysCloudAPIRegion): void {
    const existingRegion = this.authService.getSelectedRegion();
    const hasSession = this.authService.getPKCETokenFromSession();

    if (hasSession && existingRegion?.env === region.env) {
      void this.router.navigate(['/video']);
      return;
    }

    this.authService.setSelectedRegion(region);
    void this.authService.initializeAuth();
  }

  onNoSignInClick(): void {
    this.router.navigate(['/no-signin-watch-video']);
  }
}
